/* Copyright (c) 2020-present CloudIO Inc */

import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  ExpressionValue,
} from '../../registry/Component.type';

export interface EventSubscriptionItem extends BaseComponentItem {
  props: EventSubscription;
  type: 'EventSubscription';
}

export interface EventSubscription extends CommonProps {
  context: ExpressionValue;
  contextId: ExpressionValue;
  // timeStamp: ExpressionValue;
}

export const defaultValue: Required<EventSubscription> = {
  ...defaultCommonProps,
  context: { value: '', type: 'text' },
  contextId: { value: '', type: 'text' },
  // timeStamp: { value: '', type: 'text' },
};
